import React from 'react';
import { useSignedUrl } from '@/hooks/useSignedUrl';

interface SignedImageProps extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> {
  /** S3 key or absolute URL */
  readonly src: string | null | undefined;
}

/**
 * Drop-in replacement for <img> that auto-resolves S3 keys to presigned URLs.
 */
export function SignedImage({ src, className, alt, ...rest }: SignedImageProps) {
  const resolvedUrl = useSignedUrl(src);

  if (!resolvedUrl) return null;

  return (
    <img
      src={resolvedUrl}
      alt={alt ?? ''}
      className={className}
      loading="lazy"
      decoding="async"
      {...rest}
    />
  );
}
